import {
  PermissionActions,
  PermissionSubjects,
} from "@repo/app-types/entities/teammatePermissions";
import { SaveAndCancelButtons } from "@repo/ui/Buttons/saveAndCancelButtons";
import { Size } from "@repo/ui/helpers/helpers";
import { Label } from "@repo/ui/Label/label";
import {
  SimpleSelect,
  type SimpleSelectOption,
} from "@repo/ui/Select/simpleSelect";
import { useState } from "react";
import { Can } from "../../../helpers/teammateAuthorizationContext.js";

interface AutoAdvanceSettingProps {
  autoAdvanceAssessmentScoreThreshold: number | null;
  onSave: (autoAdvanceAssessmentScoreThreshold: number | null) => void;
}

const THRESHOLD_OPTIONS: readonly SimpleSelectOption<number | null>[] = [
  {
    label: "Disabled (recommended)",
    value: null,
  },
  {
    label: "Acceptable (3) and above",
    value: 3,
  },
  {
    label: "Good (4) and above",
    value: 4,
  },
  {
    label: "Excellent (5)",
    value: 5,
  },
];

export const AutoAdvanceSetting = ({
  autoAdvanceAssessmentScoreThreshold,
  onSave,
}: AutoAdvanceSettingProps) => {
  const [selectedThreshold, setSelectedThreshold] = useState(
    autoAdvanceAssessmentScoreThreshold,
  );

  const hasChanges =
    (selectedThreshold ?? null) !== autoAdvanceAssessmentScoreThreshold;

  return (
    <div className="space-y-2">
      <Label size={Size.SMALL}>Auto-advance candidates</Label>
      <div className="w-[220px]">
        <Can
          I={PermissionActions.UPDATE}
          a={PermissionSubjects.JOB_OPENINGS}
          passThrough={true}
        >
          {(allowed) => (
            <SimpleSelect
              value={selectedThreshold}
              onChange={setSelectedThreshold}
              options={THRESHOLD_OPTIONS}
              isDisabled={!allowed}
            />
          )}
        </Can>
      </div>
      <div className="text-sm text-muted-foreground">
        Candidates that meet or exceed this score will be automatically
        advanced. Other candidates will require recruiter review.
      </div>
      {hasChanges ? (
        <SaveAndCancelButtons
          onSave={() => {
            onSave(selectedThreshold ?? null);
          }}
          onCancel={() => {
            setSelectedThreshold(autoAdvanceAssessmentScoreThreshold);
          }}
        />
      ) : null}
    </div>
  );
};
